import React, { useState } from "react";
import PropTypes from "prop-types";
import styled, { css } from "styled-components/macro";
import { Colors, Link, inEmbedMode, queryStringParams } from "../../odc-ui";
import { Frame } from "@bitesite/react-figstrap";

const SquareCardContainer = styled.div`
  border: 1px solid ${Colors.darkGrey100};
  height: 125px;
  width: 250px;
  border-radius: 10px;
  position: relative;
  font-size: 12px;

  ${({ selectable }) => selectable && `cursor: pointer;`}
  ${({ selected, selectable }) =>
    selectable && selected && `background-color: ${Colors.gold100};`}

  ${({ theme, selected, selectable }) => {
    if (theme === "paige") {
      if (selectable && selected) {
        return css`
          background-color: ${Colors.paigeBrand200};
          color: ${Colors.white};
          border-color: ${Colors.paigeBrand200};
        `;
      } else {
        return css`
          border-color: ${Colors.paigeBrand200};
          color: ${Colors.paigeBrand200};
        `;
      }
    } else if (theme === "embed") {
      const embedPrimaryColor = queryStringParams().embed_primary_color;

      if (selectable && selected) {
        return css`
          background-color: #${embedPrimaryColor};
          color: ${Colors.white};
          border-color: #${embedPrimaryColor};
        `;
      } else {
        return css`
          background-color: ${Colors.white};
          border-color: #${embedPrimaryColor};
          color: #${embedPrimaryColor};
        `;
      }
    }
  }};
`;

const CardInfo = styled(Frame)`
  position: absolute;
  top: 40px;
  left: 15px;
`;

const CardNumber = styled.div`
  font-family: monospace;
  letter-spacing: 2px;
`;

const CardholderName = styled.div``;

const CardExpiry = styled.div``;

const CardBrand = styled.div`
  position: absolute;
  bottom: 15px;
  right: 15px;
`;

const SelectIndicator = styled.div`
  position: absolute;
  top: 15px;
  right: 15px;
  border: 1px solid ${Colors.darkGrey100};
  height: 10px;
  width: 10px;
  border-radius: 10px;
  ${({ selected }) => selected && `background-color: ${Colors.darkGrey100};`}
`;

const DisableLink = styled(Link)`
  position: absolute;
  bottom: 15px;
  left: 15px;
`;

const SquareCard = ({
  squareCard,
  selectable,
  selected,
  onClick,
  disableable,
  onDisable,
  theme,
}) => {
  const [disabling, setDisabling] = useState(false);

  const handleDisable = (e) => {
    e.preventDefault();
    if (disableable) {
      if (window.confirm("Are you sure you want to disable this card?")) {
        if (!disabling) {
          setDisabling(true);
          $.ajax({
            url: `/square_cards/${squareCard.id}/disable`,
            method: "PUT",
            success: () => {
              if (onDisable) {
                onDisable();
              }
              setDisabling(false);
            },
            error: () => {
              window.alert(
                "We're sorry, but we weren't able to diasble the card."
              );
              setDisabling(false);
            },
          });
        }
      }
    }
  };

  return (
    <SquareCardContainer
      selectable={selectable}
      onClick={onClick}
      selected={selected}
      theme={inEmbedMode() ? "embed" : theme}
    >
      {selectable && <SelectIndicator selected={selected} />}
      <CardInfo vertical gap={5}>
        <CardNumber>**** **** **** {squareCard.last_4}</CardNumber>
        <CardholderName>{squareCard.cardholder_name}</CardholderName>
        <CardExpiry>
          Exp: {squareCard.exp_month} /{" "}
          {String(squareCard.exp_year).substring(2)}
        </CardExpiry>
      </CardInfo>
      <CardBrand>{squareCard.card_brand.replaceAll("_", " ")}</CardBrand>
      {disableable && (
        <DisableLink type="danger" onClick={handleDisable}>
          {disabling ? "Disabling..." : "Disable"}
        </DisableLink>
      )}
    </SquareCardContainer>
  );
};

SquareCard.propTypes = {
  squareCard: PropTypes.object.isRequired,
  selectable: PropTypes.bool,
  selected: PropTypes.bool,
  onClick: PropTypes.func,
  disableable: PropTypes.bool,
  onDisable: PropTypes.func,
  theme: PropTypes.string,
};

export default SquareCard;
